import React from 'react'

import find from 'lodash/find'
import without from 'lodash/without'
import union from 'lodash/union'
import filter from 'lodash/filter'
import clamp from 'lodash/clamp'
import last from 'lodash/last'

import { Option, Pill } from '../../components/multi-select/multi-select-parts'

export default React.createClass({
  getDefaultProps () {
    return {
      value: []
    }
  },

  getInitialState () {
    return {
      selectedRow: null
    }
  },

  focusSearch () {
    this.refs.search.focus()
  },

  getOptionForValue (value) {
    return find(this.props.options, { value })
  },

  isSelected (value) {
    return this.props.value.includes(value)
  },

  isDisabled (value) {
    if (!value) return true
    return this.getOptionForValue(value).disabled
  },

  toggleValue (value) {
    const initialValue = this.props.value || []
    let newValue

    if (this.isDisabled(value)) {
      return
    }

    if (this.isSelected(value)) {
      newValue = without(initialValue, value)
    } else {
      newValue = union(initialValue, [value])

      if (this.getSearchableOptions().length === 1) {
        this.refs.search.value = ''
        this.props.onInputChange('')
      }
    }

    this.props.onChange(newValue)
    this.refs.search.focus()
  },

  getSearchableOptions () {
    const searchableValues = this.props.searchableValues

    const filteredOptions = filter(this.props.options, (option) => (
      searchableValues == null || searchableValues.includes(option.value))
    )
    if (filteredOptions.length == 0) return [{ value: false, label: 'This area cannot be found', disabled: true }]
    return filteredOptions
  },

  onInputChange (event) {
    this.props.onInputChange(event.target.value)
  },

  undoLastOption () {
    if (this.props.value.length === 0) return

    const lastOption = this.getOptionForValue(last(this.props.value))

    this.refs.search.value = lastOption.label
    this.toggleValue(lastOption.value)
    this.props.onInputChange(lastOption.label)
  },

  onKeyDown (event) {
    const currentRow = this.state.selectedRow
    let newRow

    switch (event.keyCode) {
      case 38:
        newRow = currentRow == null ? 0 : currentRow - 1
        this.setSelectedRow(newRow)
        break
      case 40:
        newRow = currentRow == null ? 0 : currentRow + 1
        this.setSelectedRow(newRow)
        break
      case 8:
        if (!this.refs.search.value) {
          event.preventDefault()
          this.undoLastOption()
        }

        break
      case 13:
        currentRow != null && this.toggleValue(this.props.searchableValues[currentRow])
        break
    }
  },

  setSelectedRow (row) {
    const { searchableValues = [] } = this.props
    if (row == null) {
      this.setState({ selectedRow: null })
      return
    }

    const max = searchableValues.length - 1

    this.setState({
      selectedRow: clamp(row, 0, max)
    })
  },

  handleScroll (event) {
    const list = this.refs.list
    const listContainer = this.refs.listContainer
    const listHeight = list.getBoundingClientRect().height
    const scrollHeight = listContainer.getBoundingClientRect().height

    const distanceFromBottom = scrollHeight - (list.scrollTop + listHeight)

    if (!this.state.scrolledNearBottom && distanceFromBottom < 200) {
      this.props.onScrollNearBottom()
      this.setState({ scrolledNearBottom: true })
    }
  },

  componentWillReceiveProps (nextProps) {
    if ((nextProps.searchableValues || []).length !== (this.props.searchableValues || []).length) {
      setTimeout(() => this.setState({ scrolledNearBottom: false }))
    }
  },

  render () {
    const {
      value = []
    } = this.props

    return (
      <div className='area-selector'>
        <div className='search' onClick={this.focusSearch}>
          <div className='faux-search-field'>
            {(value || []).map((value) => {
              const option = this.getOptionForValue(value)

              return (
                <Pill
                  label={option.label}
                  key={option.value}
                  onClose={() => this.toggleValue(option.value)}
                />
              )
            })}

            <input type='search' ref='search' onChange={this.onInputChange} onKeyDown={this.onKeyDown} />
          </div>
        </div>

        <div className='list-view' ref='list' onScroll={this.handleScroll}>
          <div ref='listContainer' className='list-container'>
            {this.getSearchableOptions().map(({ value, label, disabled, subLabel, subLabelWarning = false }, i) =>
              <Option
                key={value}
                selected={this.isSelected(value)}
                hovered={i === this.state.selectedRow}
                onMouseOver={() => this.setSelectedRow(i)}
                onMouseOut={() => this.setSelectedRow(null)}
                onToggle={() => this.toggleValue(value)}
                label={label}
                disabled={disabled}
                subLabel={subLabel}
                subLabelWarning={subLabelWarning}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/containers/forms/area-selector.js